import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { roleDetailActions, userActions, notificationActions, roleActions } from '../../_global/_actions';
import { withStyles } from '@material-ui/core/styles';
import { Switch, AppBar, Toolbar, IconButton, Drawer, Button, Avatar, Fab, Popper, Grow, Paper, ClickAwayListener, List, ListItem, ListItemIcon, ListItemText, ListSubheader, ListItemAvatar, ListItemSecondaryAction, Badge, Typography, Tooltip, } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import { AccountBox, ExitToApp, HelpOutlined, Notifications, CalendarToday, } from '@material-ui/icons';
import ModuleList from './ModuleList';
import Logo from '../../logo/ocean_logo.png';
import CYDialog from './CYDialog';
import BRANCHDialog from './BRANCHDialog';
import CreateNotificationDialog from './CreateNotificationDialog';
import AppNavChoose from './AppNavChoose';
import { handleUserColor } from './ColorConvertion';
import TimeAgo from 'timeago-react';
import { cutUrl } from '../../store';
import { latestVersion } from '../../page/Version';

const styles = theme => ({
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
    },
    badge: {
        top: '20%', right: -3, border: '2px solid #1e88e5',
    },
})

class AppNav extends React.Component {
    state = {
        left: false,
        anchorEl: null,
        openAvatar: false,
        OpenCYDialog: false,
        openNotification: false,
        isChoose: false,
        OpenBranchDialog: false,
        OpenCreateNotification: false,
        Roles: [],
        NotificationLogs: [],
    };

    //#region Cy Dialog
    handleCYDialog = () => {
        this.setState(prevState => ({ OpenCYDialog: !prevState.OpenCYDialog }));
    }
    handleCYSubmit = value => {
        // console.log(value)
        const { user } = this.props;
        if (value && value.cy !== "") {
            var payload = {
                userCy: value.cy,
                userModified: user.userId,
            }
            this.props.dispatch(userActions.updateUserCy(payload, user.userId, user.id));
            // this.handleCYDialog();
        }
        else {
            alert('Error: CY is Empty');
        }
    }
    //#endregion

    componentDidMount() {
        if (this.props.user) {
            const { user } = this.props;
            // console.log(user)
            this.props.dispatch(roleDetailActions.getAccessByMenu(user.roleId, "MENU"));
            this.props.dispatch(roleActions.getActiveRoles());
            const branch = user.branches.find(branch => branch.defaultBranch === true);
            this.setState({ currentBranch: branch });

            if (user.isDat && !user.userCy && user.allCy && user.allCy.length > 0) {
                this.handleCYDialog();
            }

            this.handleGetNotification();
        }
    }

    // handleMenu = event => {
    //     this.setState({ anchorEl: event.currentTarget });
    // };

    // handleClose = () => {
    //     this.setState({ anchorEl: null });
    // };
    //#region Menu
    toggleDrawer = (side, open) => () => {
        this.setState({ [side]: open, });
    };

    avatar = name => {
        return name.slice(0, 1);
    }
    //#endregion

    //#region my account
    handleToggle = () => {
        if (this.state.openNotification) this.setState(state => ({ openAvatar: !state.openAvatar, openNotification: false }));
        else this.setState(state => ({ openAvatar: !state.openAvatar }));
    };

    handleCloseAvatar = event => {
        if (this.anchorEl.contains(event.target)) {
            return;
        }
        this.setState({ openAvatar: false });
    };
    //#endregion

    logout = () => {
        this.props.dispatch(userActions.logout(this.props.user.id, this.props.user.userId));
    }

    //#region Notification
    handleToggleNotification = () => {
        this.setState(state => ({ openNotification: !state.openNotification, openAvatar: false }));
        if (!this.state.openNotification === true) {
            this.handleGetNotification();
        }
    };

    handleCloseNotification = (condition) => {
        if (condition !== 'away') {
            // const { NotificationLogs } = this.props;
            // var LogData = NotificationLogs.find(log => log.id === condition);
            var isViewed = true;
            // console.log(LogData)
            this.props.dispatch(notificationActions.UpdateNotification(isViewed, condition));
        }
        this.setState({ openNotification: false });
    };

    handleGetNotification = () => {
        const { user } = this.props;
        this.props.dispatch(notificationActions.GetNotificationLogs(user.userId, user.roleId));
    }

    handleClearNotification = () => {
        const { user } = this.props;
        this.props.dispatch(notificationActions.ClearNotifications(user.userId, user.roleId));
        this.setState({ openNotification: false });
    }
    //#endregion

    //#region Choose Dialog
    handleChoose = () => {
        const { user } = this.props;
        if(user.isDat){
            this.setState({ isChoose: !this.state.isChoose })
        }
        else{
           this.handleBranchDialog()
        }

    }

    handleChooseDialog = (actionType) => {
        if(actionType === 'cy'){
            this.handleCYDialog();
        }
        else if (actionType === 'branch'){
            this.handleBranchDialog();
        }
        this.handleChoose()
    }
    //#endregion

    //#region Branch Dialog
    handleBranchDialog = () => {
        this.setState(prevState => ({ OpenBranchDialog: !prevState.OpenBranchDialog }));
    }
    handleBranchSubmit = value => {
        const { branch } = value;
        const { user } = this.props;
        let defaultBranch = branch.find(b => b.defaultBranch)
        if(defaultBranch){
            if(defaultBranch.id){
                var payload = { id: defaultBranch.id, defaultBranch: true }
                this.props.dispatch(userActions.updateUserBranch(payload, user.userId, user.id));
                // this.handleBranchDialog();
            }
            else{
                alert('Error: ID not found! Please try to re-Login and try again.');
                this.handleBranchDialog();
            }
        }
    }
    //#endregion

    //#region Create Notification
    handleCreateNotificationDialog = () => {
        this.setState(prevState => ({ OpenCreateNotification: !prevState.OpenCreateNotification }));
    }
    handleSubmitNotification = () => {

    }
    //#endregion

    UNSAFE_componentWillReceiveProps(nextProps){
        if(nextProps.roles && nextProps.roles.length > 0 && nextProps.roles !== this.props.roles){
            this.setState({ Roles: nextProps.roles })
        }
        if(nextProps.NotificationLogs && nextProps.NotificationLogs !== this.props.NotificationLogs){
            // console.log('nextProps.NotificationLogs', nextProps.NotificationLogs)
            this.setState({ NotificationLogs: nextProps.NotificationLogs });
        }
    }

    render() {
        const { user, classes, path, userSubmitting } = this.props;
        const { OpenCYDialog, OpenBranchDialog, currentBranch, OpenCreateNotification, Roles, NotificationLogs, } = this.state;
        // const { anchorEl } = this.state;
        // const open = Boolean(anchorEl);
      
        var badgeCount = 0;
        var NotificationList;
        // console.log(NotificationLogs)
        if (NotificationLogs && NotificationLogs.length > 0) {
            NotificationLogs.forEach(log => {
                if (log.isViewed === false) {
                    badgeCount++
                }
            });
            NotificationList = NotificationLogs.filter(l => l.isViewed === false)
        }
        return (
            <div>
                {
                    user ? (
                        <React.Fragment>
                            <AppBar elevation={0} position="fixed" className={classes.appBar}>
                                <Toolbar variant='dense'>
                                    <IconButton style={{ marginLeft: -12, marginRight: 16, }} color="inherit" aria-label="Menu" onClick={this.toggleDrawer('left', true)}><MenuIcon fontSize='small' /></IconButton>
                                    {window.screen.width > 768 ? <Link to='/' className='link'><img src={Logo} alt="logo" style={{ width: 90, height: 25 }} /></Link> : null}
                                    <Tooltip title="Version Updates" placement="bottom">
                                        <Button style={{ marginLeft: window.screen.width > 768 ? 10 : 0 }} color="inherit" size='small' component={Link} to='/version'> {latestVersion}</Button>
                                    </Tooltip>
                                    <div style={{ flexGrow: 1, marginLeft: 10 }}>
                                        <Tooltip title="Select Branch" placement="bottom">
                                            <Button size="small" onClick={this.handleChoose} style={{ color: '#ffffff' }} >{currentBranch ? currentBranch.branchName : ''}</Button>
                                        </Tooltip>
                                    </div>
                                    {
                                        window.screen.width > 768 ?
                                            <Tooltip title="Notification" placement="bottom">
                                                <Fab size='small' color="primary" aria-label="Notification" buttonRef={node => {this.anchorEl = node;}} aria-owns={this.state.openNotification ? 'menu-list-grow' : undefined} aria-haspopup="true" onClick={this.handleToggleNotification} style={{ boxShadow: "none", marginRight: 14, }} elevation={0} >
                                                    <Badge color="secondary" badgeContent={badgeCount && badgeCount > 0 ? badgeCount : 0} invisible={badgeCount && badgeCount > 0 && !this.state.openNotification ? false : true} classes={{ badge: classes.badge }}> <Notifications /></Badge>
                                                </Fab>
                                            </Tooltip>
                                     : null
                                    }
                                    <Tooltip title="Account Settings" placement="bottom">
                                        <Fab size='small' color="primary" aria-label="Avatar" buttonRef={node => { this.anchorEl = node; }} aria-owns={this.state.openAvatar ? 'menu-list-grow' : undefined} aria-haspopup="true" onClick={this.handleToggle} style={{ boxShadow: "0px 0px 1px 1px #ffffff" }} elevation={2} >
                                            {   window.screen.width > 768 ? this.avatar(user.name)
                                                : (<Badge color="secondary" badgeContent={badgeCount && badgeCount > 0 ? badgeCount : 0} invisible={badgeCount && badgeCount > 0 && !this.state.openAvatar ? false : true} classes={{ badge: classes.badge }}> <span style={{ width: 25 }}>{this.avatar(user.name)} </span></Badge>)
                                            }
                                        </Fab>
                                    </Tooltip>
                                    <Popper open={this.state.openNotification} style={{ marginTop: 6, marginRight: -2 }} anchorEl={this.anchorEl} transition disablePortal>
                                        {({ TransitionProps, placement }) => (
                                            <Grow {...TransitionProps} id="menu-list-grow" style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }} >
                                                {NotificationList && NotificationList.length > 0 ?
                                                    <Paper elevation={1} square={true} style={{ width: '100%', maxWidth: 350, height: '100%', }}>
                                                        <ClickAwayListener onClickAway={() => this.handleCloseNotification('away')}>
                                                            <List dense disablePadding>
                                                                <ListSubheader style={{ borderBottom: '1px solid #ccc', backgroundColor: '#ffffff', height: 40 }}>
                                                                    <ListItemText><Typography variant="subtitle2" style={{ paddingTop: 9 }}>Notifications</Typography></ListItemText>
                                                                    <ListItemSecondaryAction><Button variant="text" size="small" style={{ fontSize: 11 }} onClick={this.handleClearNotification}>Clear Notification</Button></ListItemSecondaryAction>
                                                                </ListSubheader>
                                                                <div style={{ maxHeight: 400, overflowY: 'auto',}}>
                                                                {
                                                                    NotificationList.map((log, id) => {
                                                                        const toUrl = log.url ? cutUrl(log.url) : '';
                                                                        let logoChar = '';
                                                                        let logoBoolean = false;
                                                                        if(log.title === 'Booking Changes'){
                                                                            logoChar = 'BC';
                                                                        }
                                                                        else if(log.title === 'Unloading Tally Sheet'){
                                                                            logoChar = 'IT';
                                                                        }
                                                                        else if(log.title === 'Unload List'){
                                                                            logoChar = 'IU';
                                                                        }
                                                                        else if(log.title === 'Load List'){
                                                                            logoChar = 'OL';
                                                                        }
                                                                        else if(log.title === 'Loading Tally Sheet'){
                                                                            logoChar = 'OT';
                                                                        }
                                                                        else if(log.title === 'Sales Quotation'){
                                                                            logoChar = 'SQ';
                                                                        }
                                                                        else if(log.title === 'Vessel Updates'){
                                                                            logoChar = 'VU';
                                                                        }
                                                                        else if(log.title === 'Waiver'){
                                                                            logoChar = 'WV';
                                                                        }
                                                                        else if(log.title === 'Customer Request'){
                                                                            logoChar = 'CR';
                                                                        }
                                                                        else{
                                                                            logoChar = log.userId;
                                                                            logoBoolean = true;
                                                                        }
                                                                        return (
                                                                            < ListItem key={id} button component={Link} to={toUrl} onClick={() => this.handleCloseNotification(log.id)} style={{ borderBottom: '1px solid #ccc' }} >
                                                                                <ListItemAvatar>
                                                                                    <Avatar style={{ height: 30, width: 30, backgroundColor: handleUserColor(logoChar) }}>{logoBoolean ? this.avatar(logoChar) : logoChar}</Avatar>
                                                                                </ListItemAvatar>
                                                                                <ListItemText
                                                                                    primary={log.title}
                                                                                    secondary={<React.Fragment>
                                                                                            <span>{log.message}</span><br />
                                                                                            {<TimeAgo datetime={log.dateCreated} style={{ fontSize: 10 }} />}
                                                                                        </React.Fragment>}
                                                                                />
                                                                            </ListItem>
                                                                        )
                                                                    })
                                                                }
                                                                </div>
                                                                <ListItem button component={Link} to={'/notifications'} onClick={() => this.handleCloseNotification('away')} style={{ borderBottom: '1px solid #ccc', color: '#1e88e5' }} className="userlink" >
                                                                    <ListItemText primary={'View All Notifications'} /> 
                                                                </ListItem>
                                                            </List>
                                                        </ClickAwayListener>
                                                    </Paper>
                                                    :
                                                    <Paper elevation={1} square={true} style={{ width: '100%', maxWidth: 350, height: '100%', maxHeight: 500, overflowY: 'auto', }}>
                                                        <ClickAwayListener onClickAway={() => this.handleCloseNotification('away')}>
                                                            <List dense disablePadding>
                                                                <ListSubheader style={{ borderBottom: '1px solid #ccc', backgroundColor: '#ffffff' }}>{'Notifications'}</ListSubheader>
                                                                <ListItem style={{ borderBottom: '1px solid #ccc' }} ><ListItemText secondary={'No New Notification Yet'} /> </ListItem>
                                                                <ListItem button component={Link} to={'/notifications'} onClick={() => this.handleCloseNotification('away')} style={{ borderBottom: '1px solid #ccc', color: '#1e88e5' }} className="userlink" ><ListItemText primary={'View All Notifications'} /> </ListItem>
                                                            </List>
                                                        </ClickAwayListener>
                                                    </Paper>
                                                }
                                            </Grow>
                                        )}
                                    </Popper>
                                    <Popper open={this.state.openAvatar} style={{ marginTop: 6, marginRight: -2 }} anchorEl={this.anchorEl} transition disablePortal>
                                        {({ TransitionProps, placement }) => (
                                            <Grow {...TransitionProps} id="menu-list-grow" style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }} >
                                                <Paper>
                                                    <ClickAwayListener onClickAway={this.handleCloseAvatar}>
                                                        <List dense>
                                                            <ListItem style={{ borderBottom: '1px solid #ccc' }}>
                                                                <ListItemIcon>
                                                                    <Avatar>{this.avatar(user.name)}</Avatar>
                                                                </ListItemIcon>
                                                                <ListItemText primary={user.name} secondary={user.email} />
                                                            </ListItem>
                                                            <ListItem button component={Link} to={'/myAccount'} onClick={this.handleCloseAvatar}>
                                                                <ListItemIcon>
                                                                    <AccountBox fontSize='small' />
                                                                </ListItemIcon>
                                                                <ListItemText primary="My profile" />
                                                            </ListItem>
                                                            {
                                                                window.screen.width > 768 ? null
                                                                : 
                                                                <ListItem button onClick={this.handleToggleNotification}>
                                                                    <ListItemIcon>
                                                                    <Badge color="secondary" badgeContent={badgeCount && badgeCount > 0 ? badgeCount : 0} invisible={badgeCount && badgeCount > 0 && !this.state.openNotification ? false : true} classes={{ badge: classes.badge }} > <Notifications fontSize='small'/></Badge>
                                                                    </ListItemIcon>
                                                                    <ListItemText primary="Notification" />
                                                                </ListItem>
                                                            }
                                                            <ListItem button component={Link} to={'/calendar'} onClick={this.handleCloseAvatar}>
                                                                <ListItemIcon>
                                                                    <CalendarToday fontSize='small' />
                                                                </ListItemIcon>
                                                                <ListItemText primary="Calendar" />
                                                            </ListItem>
                                                            {/* <ListItem button onClick={this.handleCreateNotificationDialog}>
                                                                <ListItemIcon>
                                                                    <QuestionAnswer fontSize='small' />
                                                                </ListItemIcon>
                                                                <ListItemText primary="Create Notification" />
                                                            </ListItem> */}
                                                            <ListItem>
                                                                <ListItemIcon>
                                                                    <Switch color="primary" edge="start" checked={user.darkMode} onChange={this.props.toggleTheme} size="small" />
                                                                </ListItemIcon>
                                                                <ListItemText primary={"Dark Mode"} />
                                                            </ListItem>
                                                            <ListItem button component={Link} to={'/help_support'} onClick={this.handleCloseAvatar}>
                                                                <ListItemIcon>
                                                                    <HelpOutlined fontSize='small' />
                                                                </ListItemIcon>
                                                                <ListItemText primary="Help and Support" />
                                                            </ListItem>
                                                            <ListItem button onClick={this.logout}>
                                                                <ListItemIcon>
                                                                    <ExitToApp fontSize='small' />
                                                                </ListItemIcon>
                                                                <ListItemText primary="Sign out" />
                                                            </ListItem>
                                                        </List>
                                                    </ClickAwayListener>
                                                </Paper>
                                            </Grow>
                                        )}
                                    </Popper>
                                    {/* <Avatar style={{ height: 30, width: 30, fontSize: 15, marginRight: 2, backgroundColor: '#ed4b82', cursor: 'pointer' }}>{this.avatar(user.name)}</Avatar> */}
                                    {/* <Button size="small" color="inherit" onClick={() => this.props.dispatch(userActions.logout(user.id))}>Logout</Button> */}
                                </Toolbar>
                            </AppBar>
                            <Drawer open={this.state.left} onClose={this.toggleDrawer('left', false)}>
                                <div tabIndex={0} role="button" onClick={this.toggleDrawer('left', false)} onKeyDown={this.toggleDrawer('left', false)}>
                                    <ModuleList />
                                </div>
                            </Drawer>
                            <CYDialog cy={user.userCy} saving={userSubmitting} open={OpenCYDialog} data={user.allCy} branch={currentBranch} handleClose={this.handleCYDialog} handleSubmit={this.handleCYSubmit} />
                            <BRANCHDialog branch={user.branches} saving={userSubmitting} open={OpenBranchDialog} handleClose={this.handleBranchDialog} handleSubmit={this.handleBranchSubmit} />
                            {
                                OpenCreateNotification ? 
                                    <CreateNotificationDialog open={OpenCreateNotification} handleClose={this.handleCreateNotificationDialog} handleSubmit={this.handleSubmitNotification} Roles={Roles}/>
                                : null
                            }
                            <AppNavChoose handleSubmit={this.handleChooseDialog} show={this.state.isChoose} handleClose={this.handleChoose} />
                        </React.Fragment>
                    ) : (
                            <React.Fragment>
                                <AppBar elevation={0} position="fixed">
                                    <Toolbar variant='dense'>
                                        {
                                            path.substring(0, 8) === '/booking' ? (
                                                <React.Fragment>
                                                    <img src={Logo} alt="logo" style={{ width: 90, height: 25 }} />
                                                </React.Fragment>
                                            ) : (
                                                    <React.Fragment>
                                                        <div style={{ flexGrow: 1 }}>
                                                            <Link to='/' className='link'><img src={Logo} alt="logo" style={{ width: 90, height: 25 }} /></Link>
                                                        </div>
                                                        <Button size="small" color="inherit" component={Link} to="/signin">Sign in</Button>
                                                    </React.Fragment>
                                                )
                                        }
                                    </Toolbar>
                                </AppBar>
                            </React.Fragment>
                        )
                }
            </div>
        )
    }
}
function mapStateToProps(state) {
    const { notificationFetching, NotificationLogs } = state.notification;
    const { roles } = state.roles;
    const { userSubmitting } = state.users;
    return {
        notificationFetching, NotificationLogs,
        roles,
        userSubmitting,
    };
}
export default connect(mapStateToProps)(withStyles(styles)(AppNav))